import { useState, useEffect } from 'react';
import { doc, onSnapshot, updateDoc, arrayUnion, getDoc, setDoc } from 'firebase/firestore';
import { firestore } from './firebase';
import { sendEmailViaHeroku } from './emailService';

export function useAdminThreadMessages(itemId, userEmail, currentUserEmail, itemTitle) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Create thread ID: itemId_userEmail
  const threadId = itemId && userEmail ? `${itemId}_${userEmail}` : null;

  useEffect(() => {
    if (!threadId) {
      setMessages([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    // Listen to the thread document for real-time updates
    const threadRef = doc(firestore, 'offers', threadId);
    const unsubscribe = onSnapshot(
      threadRef,
      (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          setMessages(data.messages || []);
        } else {
          setMessages([]);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to thread:', err);
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [threadId]);

  const sendMessage = async (messageText, sendEmail = false) => {
    console.log('sendMessage', messageText, sendEmail);
    console.log('threadId', threadId);
    console.log('userEmail', userEmail);
    if (!threadId || !messageText.trim()) return;

    const newMessage = {
      message: messageText.trim(),
      user: currentUserEmail,
      timestamp: new Date()
    };

    try {
      const threadRef = doc(firestore, 'offers', threadId);
      
      // Check if thread exists
      const threadDoc = await getDoc(threadRef);
      
      if (threadDoc.exists()) {
        // Thread exists, append to messages array
        await updateDoc(threadRef, {
          messages: arrayUnion(newMessage)
        });
      } else {
        // Thread doesn't exist, create it with first message
        await setDoc(threadRef, {
          itemId,
          userEmail,
          messages: [newMessage],
          createdAt: new Date()
        });
      }

      // Send email notification if requested
      if (sendEmail) {
        console.log('Sending email notification');  
        console.log('messageText', messageText);
        console.log('userEmail', userEmail);
        console.log('itemId', itemId);
        console.log('currentUserEmail', currentUserEmail);
        try {
          await sendEmailViaHeroku({
            message: `"${messageText.trim()}"\n\n<a href="https://titledworks.com/item/${itemId}#offer">${itemTitle}</a>`,
            user: 'Titled Works', // From display
            recipient: userEmail, // The user to send the email to
            itemId: itemId,
          });
        } catch (emailError) {
          console.error('Email notification failed:', emailError);
          // Don't fail the message send if email fails
        }
      }

      return true;
    } catch (err) {
      console.error('Error sending message:', err);
      setError(err);
      return false;
    }
  };

  return {
    messages,
    loading,
    error,
    sendMessage
  };
} 